// 订单相关得Api
import { COU_httpPost } from "@/utils/http";

// 获取订单列表
async function GetOrders(mallGroupRelationIds, data) {
  var url = `oneorder/order/list?needPurchasedOrder=true&mallGroupRelationIds=${mallGroupRelationIds}`;
  var r = await COU_httpPost({ url, data });
  let itemList = [],
    total = 0,
    errMsg = null;
  try {
    errMsg = !r.success ? r.msg : "";
    itemList = r.result.Datas;
    total = r.result.TotalNum;
  } catch (error) {
    console.log(error);
  }
  if (!itemList) itemList = [];
  return { itemList, total, errMsg, hasMore: itemList.length >= data.pageSize };
}
// // 获取订单列表
// async function GetOrdersSimple(mallGroupRelationIds, data) {
//   var url = `oneorder/order/simpleList?mallGroupRelationIds=${mallGroupRelationIds}`;
//   var r = await COU_httpPost({ url, data });
//   let itemList = [],
//     total = 0,
//     errMsg = null;
//   try {
//     errMsg = !r.success ? r.msg : "";
//     itemList = r.result.Datas;
//     total = r.result.TotalNum;
//   } catch (error) {
//     console.log(error);
//   }
//   if (!itemList) itemList = [];
//   return { itemList, total, errMsg, hasMore: itemList.length >= data.pageSize };
// }

// 获取订单列表
async function GetOrdersSimple(
  localStatus,
  currentPage,
  pageSize,
  relationList,
  searchCondition,
  isAfter,
  afterSalesStatus,
  type,
  autoOperation
) {
  let mallGroupRelationIds = "";
  const relationIdList = [];
  if (relationList) {
    relationList.forEach((item) => {
      relationIdList.push(item.Id);
    });
    mallGroupRelationIds = relationIdList.join(",");
  }

  const url = `oneorder/order/${
    type !== "is-simple" ? "list" : "simpleList"
  }?mallGroupRelationIds=${mallGroupRelationIds}`;

  const data = {
    relationIdsStr: relationIdList.join(","),
    // currentPage: currentPage,
    // pageSize: pageSize,
    page: currentPage,
    size: pageSize,
    localStatus: localStatus,
    // 是否筛选延迟处理的订单 true为延迟处理的订单, false为正常的订单(就是不延迟处理的)
    isPending: searchCondition?.isPending ? true : false,
    autoOperation: autoOperation ? true : false, // 是否是自动操作时获取的
  };
  if (isAfter) {
    data.localStatus = "";
    if (searchCondition?.afterSalesStatusStr) data.afterSalesStatusStr = searchCondition.afterSalesStatusStr;
    else data.afterSalesStatus = afterSalesStatus;
    data.hasRefund = 1;
  }
  if (searchCondition) {
    const { orderInfoStartTime, orderInfoEndTime, orderSnStr, order } = searchCondition;
    // 付款时间段
    if (!isAfter && orderInfoStartTime) data.orderInfoStartTime = orderInfoStartTime;
    if (!isAfter && orderInfoEndTime) data.orderInfoEndTime = orderInfoEndTime;
    // 售后时间段
    if (isAfter && orderInfoStartTime) data.afterSaleCreatedTimeStart = orderInfoStartTime;
    if (isAfter && orderInfoEndTime) data.afterSaleCreatedTimeEnd = orderInfoEndTime;

    if (orderSnStr) data.orderSnStr = orderSnStr;
    if (order) data.order = order;
    if (searchCondition.phone) data["BuyerReceiverAddress.ReceiverPhone"] = searchCondition.phone;
    if (searchCondition.consignee) data["BuyerReceiverAddress.ReceiverName"] = searchCondition.consignee;
    if (searchCondition.title) data["ItemInfos.GoodsName"] = searchCondition.title;
    if (searchCondition.SKUID) data["ItemInfos.SkuId"] = searchCondition.SKUID;
    if (searchCondition.platformType && searchCondition.platformType != "all")
      data["PurchasedOrderInfo.PlatFormType"] = searchCondition.platformType;
    if (searchCondition.logistics && searchCondition.platformType != "all")
      data["TrackingInfo.LogisticsId"] = searchCondition.logistics;
    if (searchCondition.account) data["PurchasedOrderInfo.BuyerInfo.Name"] = searchCondition.account;
    if (searchCondition.orderId) data["PurchasedOrderInfo.OrderId"] = searchCondition.orderId;
    if (searchCondition.trackingNumber) data["TrackingInfo.TrackingNumber"] = searchCondition.trackingNumber;
    if (searchCondition.flag) data["OrderInfo.SellerRemarkStars"] = searchCondition.flag;
    if (searchCondition.mallMark) data["OrderInfo.SellerWords"] = searchCondition.mallMark;
    if (searchCondition.parentOrderId) data["OrderInfo.ParentOrderId"] = searchCondition.parentOrderId;
    if (searchCondition.provinces && searchCondition.provinces.length > 0)
      data["BuyerReceiverAddress.Province"] = searchCondition.provinces.join(",");
    if (searchCondition.priceStart && searchCondition.priceEnd) {
      data["ItemInfos.TotalPriceStart"] = searchCondition.priceStart * 100;
      data["ItemInfos.TotalPriceEnd"] = searchCondition.priceEnd * 100;
    }
    if (searchCondition.goodCountStart && searchCondition.goodCountEnd) {
      data["ItemInfos.GoodsCountStart"] = searchCondition.goodCountStart;
      data["ItemInfos.GoodsCountEnd"] = searchCondition.goodCountEnd;
    }
    if (searchCondition.goodsCode) data["ItemInfos.GoodsId"] = searchCondition.goodsCode;
    data.hideGiftGood = searchCondition.hideGiftGood;
  }
  const result = await COU_httpPost({ url, data });
  let itemList = [],
    totalNum = 0,
    errMsg = null;
  try {
    if (!result.success) errMsg = result.msg;
    else {
      //if (type !== "is-simple") {
      itemList = result.result.Datas;
      totalNum = result.result.TotalNum;
      //} else itemList = result.result;
    }
  } catch (e) {
    console.log(e);
  }
  //不存在的情况下还原回来
  if (!itemList) itemList = [];
  else {
    itemList.map((item) => {
      // 保存当前的状态(是否是延迟处理的订单)
      item.isPending = data.isPending;
      // 如果是赠品订单
      if (
        (item.OrderInfo.SkuOrderTagUiList?.[0]?.Text === "赠品" || item.OrderInfo.GivenProductType === "FREE") &&
        item.OrderInfo.MasterSkuOrderIdList?.[0]
      ) {
        item.zengpinData = {
          parentId: item.OrderInfo.MasterSkuOrderIdList[0],
          text: "赠品",
        };
      }
    });
  }
  return { itemList, totalNum, errMsg, hasMore: itemList.length >= pageSize };
}

// 同步订单(选择店铺的所有订单)
async function SyncOrders(orderInfoEndTime, orderInfoStartTime, mallGroupRelationIds) {
  var url = `/oneorder/order/syncOrderList?mallGroupRelationIds=${mallGroupRelationIds}`;
  var data = {
    startConfirmAt: orderInfoStartTime,
    endConfirmAt: orderInfoEndTime,
  };
  var r = await COU_httpPost({ url, data });
  var msg = ``;
  var isSuccess = false;
  try {
    msg = r.msg;
    isSuccess = r.success;
  } catch (error) {
    console.log(error);
  }
  return { msg, isSuccess };
}
// 同步订单 (根据订单号)
async function SyncOrdersByIds({ orderIds, relationId }) {
  const url = `/oneorder/order/syncOrderByIds?relationId=${relationId}`;
  const r = await COU_httpPost({ url, data: { orderIds } });
  let msg = "";
  let isSuccess = false;
  try {
    msg = r.msg;
    isSuccess = r.success;
  } catch (error) {
    console.log(error);
  }
  return { msg, isSuccess };
}

// 同步订单状态
async function SyncMallOrder(orderId) {
  var errMsg = "";
  var newOrderInfo = null;
  var url = `/oneorder/order/syncOrder`;
  var data = {
    orderId,
  };
  var r = await COU_httpPost({ url, data });
  if (!r.success) errMsg = r.msg;
  if (r?.result) newOrderInfo = r.result;
  return { errMsg, newOrderInfo };
}

//添加本地备注
async function UpdateLocalMark(localMark, orderId) {
  var urlStr = `/oneorder/order/updateLocalMark`;
  var data = {
    localMark,
    orderId,
  };
  var result = await COU_httpPost({ url: urlStr, data });
  console.log(result);
  var orderInfo = null;
  var errMsg = null;
  try {
    if (!result.success) errMsg = result.msg;
    else orderInfo = result.result;
  } catch (e) {
    console.log(e);
  }
  return { orderInfo, errMsg };
}

// 添加商家备注
async function UpdateMallMark(mallRemark, orderId, tag) {
  var url = `/oneorder/order/updateMallMark`;
  var data = {
    orderId,
    mallRemark,
    tag,
  };
  var r = await COU_httpPost({ url, data });
  var orderInfo = null;
  var errMsg = null;
  try {
    if (!r.success) errMsg = r.msg;
    else orderInfo = r.result.OrderInfo;
  } catch (e) {
    console.log(e);
  }
  return { orderInfo, errMsg };
}

// 延迟处理
async function ChangeOrderPending({ orderId, operation }) {
  var url = `/oneorder/order/changeOrderPending`;
  var data = {
    orderId,
    operation,
  };
  var r = await COU_httpPost({ url, data });
  let msg = "",
    success = false;
  try {
    msg = r.msg;
    success = r.success;
  } catch (error) {
    console.log(error);
  }
  return { msg, success };
}

// 发货
async function ManaulSendOrders(orderId) {
  var url = `/oneorder/order/faHuoOrder`;
  var data = {
    orderId,
  };
  var r = await COU_httpPost({ url, data });
  var errMsg = ``;
  try {
    if (!r.success) {
      errMsg = r.msg;
    }
  } catch (e) {
    console.log(e);
  }

  return { errMsg };
}
//手动 发货
async function HandSendOrders(data) {
  var url = `/oneorder/order/faHuoByTrackingNumber`;

  var r = await COU_httpPost({ url, data });
  var errMsg = ``;
  try {
    if (!r.success) {
      errMsg = r.msg;
    }
  } catch (e) {
    console.log(e);
  }

  return { errMsg };
}

async function GetOrderInfoByOrderId(orderId, branchRelId) {
  const url = `/oneorder/order/ali/orderDetailByOrderId?branchRelId=${branchRelId}`;
  const r = await COU_httpPost({ url, data: { orderId: orderId } });
  let msg = "";
  let isSuccess = false;
  let authInfo;
  try {
    msg = r.msg;
    isSuccess = r.success;
    authInfo = r.result;
  } catch (error) {
    console.log(error);
  }
  return { msg, isSuccess, authInfo };
}

// 检查1688订单是否已发货
async function CheckTb1688OrderSend(orderSn) {
  const url = `/oneorder/order/ali/checkOrderSend`;

  const r = await COU_httpPost({ url, data: { orderId: orderSn } });
  let msg,
    isSuccess = false,
    authInfo;
  try {
    isSuccess = r.success;
    msg = r.msg;
    authInfo = r.result;
  } catch (error) {
    console.log(error);
  }
  debugger;
  return { msg, isSuccess, authInfo };
}
async function GetLogisticsInfoByMyApi(relation, orderSn) {
  var url = `/oneorder/order/ali/orderLogistics?groupId=${relation}`;

  var data = {
    orderId: orderSn,
  };
  var r = await COU_httpPost({ url, data });
  if (typeof r?.result === "string" && r?.result?.includes("auth.1688.com") && r.msg?.includes("授权"))
    return { authUrl: r.result };
  var logisticsInfo = {};
  var errMsg = ``;
  var isCollect = true;
  try {
    logisticsInfo = r.result.LogisticInfos;
    logisticsInfo["shipping_name"] = r.result.LogisticInfos[0]?.LogisticsName;
    logisticsInfo["tracking_number"] = r.result.LogisticInfos[0]?.TrackingNumber;
    logisticsInfo["traces"] = updataTraces(r.result.LogisticInfos[0]?.LogisticTracks);
    // logisticsInfo["shipping_name"] = r.result.LogisticInfos[0]?.logisticsCompanyName;
    // logisticsInfo["tracking_number"] = r.result.LogisticInfos[0]?.logisticsBillNo;
    // logisticsInfo["traces"] = updataTraces(r.result.logisticTrace[0]?.logisticsSteps);
    errMsg = r.result.LogisticInfos[0]?.LogisticTracks.length > 0 ? "" : r.result.LogisticInfos[0]?.LogisticTracks;
    //if (!r.result.logisticTrace[0]?.logisticsSteps) isCollect = false;
    if (!r.result.LogisticInfos[0]?.LogisticTracks || r.result.LogisticInfos[0]?.LogisticTracks.length == 0)
      isCollect = false;
    logisticsInfo["isCollect"] = isCollect;
  } catch (error) {
    console.log(error);
  }
  return { logisticsInfo, errMsg };
}
function updataTraces(logisticsSteps) {
  if (!logisticsSteps || (logisticsSteps && logisticsSteps.length == 0)) return;
  var traces = logisticsSteps.map((item) => {
    var newItem = {
      place: item.Remark,
      time: item.AcceptTime,
    };
    return newItem;
  });
  return traces;
}

// 修改利润偏移值
async function UpdateCustomProfitAddedPrice({ orderId, price }) {
  const url = `/oneorder/order/updateCustomProfitAddedPrice`;
  const r = await COU_httpPost({ url, data: { orderId, price } });
  let msg = "",
    success = false;
  try {
    msg = r.msg;
    success = r.success;
  } catch (error) {
    console.log(error);
  }
  return { msg, success };
}

export default {
  GetOrders,
  GetOrdersSimple,
  SyncOrders,
  SyncMallOrder,
  HandSendOrders,
  UpdateLocalMark,
  UpdateMallMark,
  ChangeOrderPending,
  ManaulSendOrders,
  CheckTb1688OrderSend,
  SyncOrdersByIds,
  GetLogisticsInfoByMyApi,
  GetOrderInfoByOrderId,
  UpdateCustomProfitAddedPrice,
};
